module.exports = __webpack_public_path__ + "static/media/back9.f94837cd.jpg";